import React from "react";
import SpendingDemandListViewV2, {
  ItemSpending,
} from "../../../../spendingDemand/components/SpendingDemandList/SpendingDemandList_new/SpendingDemandListView/SpendingDemandListView";
import CollabPayedRenderer from "../../../../spendingDemand/components/SpendingDemandList/SpendingDemandList_new/SpendingDemandListView/CollabPayedRenderer";
import OrgPayedRenderer from "../../../../spendingDemand/components/SpendingDemandList/SpendingDemandList_new/SpendingDemandListView/OrgPayedRenderer";
import AcompteRenderer from "../../../../spendingDemand/components/SpendingDemandList/SpendingDemandList_new/SpendingDemandListView/AcompteRenderer";
import { useSingleTeam } from "../../../hooks";
import { dateConverter } from "../../../../../utils/dateConverter";


import { spendingDemandStatusRawToReadableStatus } from "../../../../spendingDemand/utils/spenpdingDemandStatusConverter";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../../components/organismes/Pagination/Pagination";
import Loader from "../../../../../components/atoms/Loader/Loader";


export default function SpendingDemandListPresenter() {
  const { spendingDemandList, singleTeamData} = useSingleTeam(undefined, {pageSizeSpendingDemand: 4, URLSpendingDemandPageId: "teamp"});
  const navigate = useNavigate();
  //const [page, setPage] = React.useState(1);

  const handleClick = (spendingDemandId: string) => {
    navigate('/spending_demand/'+spendingDemandId)
  }
  const { spendingDemandListData } = spendingDemandList;
  const pagination = spendingDemandListData?.pagination;
  const formated: ItemSpending[] | undefined =
    spendingDemandListData?.data?.map((spending) => {
      const statusObject = spendingDemandStatusRawToReadableStatus(
        spending.spending_demand_status,
        "for-user"
      );
      

      return {
        id: spending.spending_demand_id,
        title: spending.spending_demand_desc,
        userFirstName: spending.spending_demand_user?.username ?? '',
        userLastName: spending.spending_demand_user?.lastname ?? '',
        createdDate: dateConverter(spending.spending_demand_date),
        grossAmmount: spending.spending_demand_amountTTC,
        status: statusObject.status,
        spendingDemandReadableId: spending.spending_demand_readable_id,
        collabPayedRenderer: () => <CollabPayedRenderer spendingDemandId={spending.spending_demand_id} />,
        orgPayedRenderer: () => <OrgPayedRenderer spendingDemandId={spending.spending_demand_id} />,
        acompteRenderer: () => <AcompteRenderer spendingDemandId={spending.spending_demand_id} />,
        pinColor:
          spendingDemandStatusRawToReadableStatus(
            spending.spending_demand_status,
            "for-user"
          ).color.normal || undefined,
        withPin: spending.is_to_process,
        colorStatus: {
          backgroundColor: statusObject.color.light,
          color: statusObject.color.dark,
        },
        onClick: () => {
          handleClick(spending.spending_demand_id);
        },
      };
    });
  return (
    <>
      { spendingDemandList.isLoading ? <Loader paddingTop="0" centered /> :
      <SpendingDemandListViewV2
        spendingList={formated || []}
        emptyMessage="Aucune dépense associée à cette équipe"
      />
}
      <Pagination
        centered
        currentPage={pagination?.current_page}
        linkBase={"/teams/"+singleTeamData?.team_id}
        lastPage={pagination?.total_pages}
        paramKey="teamp"
     
      />
    </>
  );
}
